<template>
  <div :class="classes" >
    <component :is="curComponent" :index="curComponent == 'el-submenu' ? key : data.action" v-if="checkAuth(data.auth)" ref="muenItem">
        <template slot="title" v-if="curComponent == 'el-submenu'">
            <img v-if="data.img" :src="data.img" class="img-icon"/>
            <i v-else-if="data.leftIcon" :class="data.leftIcon"></i>
            <span slot="title">{{data.text}}</span>
            <i v-if="data.icon" :class="data.icon"></i>
        </template>
        <template v-for="(item,aIndex) in data.children ">
            <wt-menu-tree-item :data="item" v-if="item.enable&&(curComponent == 'el-submenu' && checkAuth(item.auth))" :index="String(aIndex + 1)" :layer="key" :key="key+'-'+aIndex" @mount-menu-item="updateMenuItem" class="children"
            :class="{'is-active':selectNumber==aIndex+1 || (selectNumber==0 && aIndex == 0)}" :selectNumber="selectNumber" @click.native="submenu(item)"></wt-menu-tree-item>
        </template>
        <template v-if="curComponent == 'el-menu-item'">
            <img v-if="data.img" :src="data.img" />
            <i v-else-if="data.leftIcon" :class="data.leftIcon"></i>
            <span slot="title" class="include-number">{{data.text}}
                <span class="number">{{data.number}}</span>
            </span>
            <i v-if="data.icon" :class="data.icon"></i>
        </template>
    </component>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-menu-tree-item'

export default {
  name: 'wt-menu-tree-item',
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String
    },
    layer: {
      type: String
    },
    selectNumber: {
      type: [Number, String]
    },
    actionUrl:{
      type:String
    }
  },
  data () {
    return {
      img: 'images/login_logo.png'
    }
  },
  computed: {
    key () {
      return this.layer ? this.layer + '-' + this.index : this.index
    },
    curComponent () {
      return this.data.children ? 'el-submenu' : 'el-menu-item'
    },
    classes () {
      return `${prefixCls}`
    }
  },
  methods: {
    // 根据子菜单筛选
    submenu (item) {
      this.$emit('getStore', item)
    },
    checkAuth (arr) {
      return true
      // return this.$auth.check(arr);
    },
    updateMenuItem (menuItem) {
      this.$emit('mount-menu-item', menuItem)
    }
  },
  mounted () {
    if (this.curComponent === 'el-menu-item') {
      this.$emit('mount-menu-item', this.$refs.muenItem)
    }
  }
}
</script>

<style lang="less">
//-----------------随便定义
.wt-menu-tree-item {
    .el-menu-item{
        border-bottom: 1px solid #d8e1e8
    }
    .el-submenu__title{
        border-bottom: 1px solid #d8e1e8;
        display: flex;
        align-items: center;
        img{
            height: auto;
            width: auto;
            max-width: 30px;
            max-height: 30px;
            margin-right: 5px;
        }
    }
}
</style>
